import { transparentize } from 'polished';
import type { PropsWithChildren } from 'react';
import styled, { useTheme, type DefaultTheme } from 'styled-components';
import { modeColor } from '../../styles';
import { Box, type BoxProps } from '../Core';
import { VStack } from '../Core/VStack';
import { NotificationWrapper } from '../Notification/styles';

const ToastWrapper = styled(Box)<{ addShadow?: boolean }>`
  ${({ theme, addShadow }) => `
    pointer-events: auto;
    border-radius: ${theme.borderRadiusDefault}px;
    ${addShadow ? `box-shadow: 0 5px 40px ${modeColor(theme, 'hsla(0, 0%, 0%, 0.1)', theme.colors.black.dim)};` : ''}
    div {
      word-break: break-word;
    }
  `}
`;

const defaultNotificationBorderShade = '100';
export const ToastSimpleWrapper = styled(NotificationWrapper)`
  ${({ theme }: { theme: DefaultTheme }) => {
    const border = transparentize(0.92, theme.colors.gray[defaultNotificationBorderShade]);
    return `
     padding: 10px;
     min-height: 38px;
     border-radius: ${theme.borderRadiusMedium}px;
     border: 1px solid ${border};
  `;
  }}
`;

/** Minimal Toast representation used for generic concepts */
export function ToastSimple({ children, ...boxProps }: PropsWithChildren<BoxProps>) {
  const theme = useTheme();
  return (
    <ToastWrapper {...boxProps}>
      <ToastSimpleWrapper size="Default" cursor="pointer">
        <VStack gap="spacing4" alignItems="center" w="100%" fontSize={theme.fontSizeSm} lineHeight="16px">
          {children}
        </VStack>
      </ToastSimpleWrapper>
    </ToastWrapper>
  );
}
